import ApplicationStatus from 'state/enums/ApplicationStatus'
import styled from 'styled-components'
import { CONTRACT_EXPIRED_STATUS } from 'utils/resolveContractStatus'

export const IconWrapper = styled.div.attrs(
    (props: { status: string }) => props,
)`
    div > svg > circle {
        fill: ${(props) =>
            (props.status === ApplicationStatus.APPROVED &&
                props.theme.colors.alert.success) ||
            (props.status === ApplicationStatus.DECLINE &&
                props.theme.colors.alert.warning) ||
            (props.status === ApplicationStatus.FUNDED &&
                props.theme.colors.label.sapphire) ||
            (props.status === ApplicationStatus.NEW_APPLICATION &&
                props.theme.colors.monochrome.concrete) ||
            (props.status === ApplicationStatus.CONTRACT_GENERATED &&
                props.theme.colors.label.fuchsia) ||
            (props.status === ApplicationStatus.PREQUALIFIED &&
                props.theme.colors.alert.success) ||
            (props.status === CONTRACT_EXPIRED_STATUS &&
                props.theme.colors.label.umber) ||
            props.theme.colors.monochrome.concrete};
    }
`
